export const fn = () => {};

export default fn;



// WEBPACK FOOTER //
// ./src/common/utils/fn.js